const avatarSize = 30;

const navigationBarPresenceStyle = {
  avatarSize,
  errorText: {
    whiteSpace: "nowrap",
    marginRight: 0.5,
    fontWeight: 500,
    lineHeight: 1,
  },
  loadingRoot: {
    marginRight: 1,
    minHeight: 48,
  },
  loadingStack: {
    pl: 1,
  },
  loadingSkeleton: (index: number) => ({
    ml: index === 0 ? 0 : -1,
    border: "2px solid",
    borderColor: "common.white",
  }),
  avatar: (backgroundColor: string, isCurrentUser: boolean) => ({
    width: avatarSize,
    height: avatarSize,
    fontSize: "0.75rem",
    fontWeight: 600,
    bgcolor: backgroundColor,
    color: "common.white",
    border: "2px solid",
    borderColor: "common.white",
    boxShadow: isCurrentUser ? "0 0 0 2px rgba(46, 125, 80, 0.32)" : "none",
    transition: "transform 150ms ease, box-shadow 150ms ease",
    ".MuiTooltip-root:hover &": {
      transform: "translateY(-1px)",
    },
  }),
  root: {
    marginRight: 1,
    minHeight: 48,
  },
  avatarGroup: {
    pl: 1,
  },
  avatarTrigger: (index: number) => ({
    ml: index === 0 ? 0 : -1,
    borderRadius: "50%",
    cursor: "default",
    "&:hover .presence-avatar, &:focus-visible .presence-avatar": {
      transform: "translateY(-1px)",
    },
    "&:focus-visible": {
      outline: "none",
    },
  }),
  overflowAvatar: {
    width: avatarSize,
    height: avatarSize,
    ml: -1,
    fontSize: "0.75rem",
    fontWeight: 600,
    bgcolor: "grey.100",
    color: "text.secondary",
    border: "2px solid",
    borderColor: "common.white",
  },
  liveDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    bgcolor: "success.main",
    boxShadow: "0 0 0 2px rgba(46, 125, 80, 0.16)",
  },
  viewingText: {
    whiteSpace: "nowrap",
    fontWeight: 500,
    lineHeight: 1,
  },
};

export default navigationBarPresenceStyle;
